import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router,
  UrlSegment,
  UrlSegmentGroup,
  UrlTree,
} from '@angular/router';
import { GeneralService } from 'src/app/providers/general/general.service';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  tap,
} from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { isQuickLinks, LoadRoleMenus } from 'src/app/state/userMap.action';
import {
  AppMenu,
  getApplication,
  GetQuickLinks,
  QuickLinksStatus,
} from 'src/app/state/userMap.reducer';
import { Application } from '../../models/header/application.interface';
import { Observable } from 'rxjs';
import { Menu } from '../../models/sidebar/sidebar.interface';
import { QuickLinks } from '../../models/header/quicklinks.interface';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { environment } from 'src/environments/environment';
import { EmployeeService } from 'src/app/providers/employee/employee.service';

declare let $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  applications$: Observable<Application[]>;
  menus$: Observable<Menu[]>;
  isQuickLinks$: Observable<boolean>;
  isQuick = false;
  menusRes: Menu[] = [];
  quickLinksMenu$: Observable<QuickLinks[]>;
  public sidebarLists: any = [];
  public response: any = [];
  public appRoute: any;
  public hasMenu: any = true;
  isPlacement:any;
  resultPlacement: any = [];

  empIDInfo: any = [];
  emplID = '';
  hasData = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private genService: GeneralService,
    private translate: TranslateService,
    private store: Store,
    private notifyService: NotificationService,
    private dashboardService: DashboardService,
    private empService: EmployeeService,
    private authSer: AuthService,
  ) {
    const tree: UrlTree = this.router.parseUrl(this.router.url);
    const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
    const s: UrlSegment[] = g.segments;
    this.appRoute = s[0].path;
    this.store.dispatch(LoadRoleMenus({ path: this.appRoute }));
    this.getSidebars();
    this.initiateSidebar();
  }

  ngOnInit(): void {
    this.idCardDetails(this.emplID);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const tree: UrlTree = this.router.parseUrl(this.router.url);
        const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
        const s: UrlSegment[] = g.segments;
        this.appRoute = s[0].path;
        this.getSidebars();
        this.initiateSidebar();
      });
    this.quickLinksMenu$ = this.store.pipe(select(GetQuickLinks));
    this.isQuickLinks$ = this.store.pipe(select(QuickLinksStatus));

      this.empService.userTypeGet().subscribe(res => {
      this.resultPlacement = res;
      this.isPlacement = this.resultPlacement.isPlacement;
      },err => {});

  }
  listRender(): void {
    const parent = this;
    setTimeout(() => {
      parent.initiateSidebar();
      $('#sidebar-menu ul li.submenu a.active')
        .parents('li:last')
        .children('a:first')
        .addClass('active')
        .trigger('click');
    }, 1000);
  }
  getSidebars(): void {
    this.hasMenu = true;
    this.menus$ = this.store.pipe(select(AppMenu, { path: this.appRoute }));

    this.menus$.subscribe((res) => {
      if (res.length === 0) {
        // this.hasMenu = false;
        this.isQuick = true;
      } else {
        this.isQuick = false;
        // this.hasMenu = true;
      }

      this.menusRes = res;
      this.initiateSidebar();
      this.listRender();
    });
    //
    // this.genService.getApplicationRoutes(this.appRoute).subscribe(res => {
    //   this.response = res;
    //   this.sidebarLists = this.response.data;
    //   if (this.sidebarLists.length > 0){
    //     this.hasMenu  = true;
    //   }else{
    //     this.hasMenu  = false;
    //   }
    //   this.initiateSidebar();
    //   this.listRender();
    // }, err => {

    // });
  }
  initiateSidebar(): void {
    let $wrapper;
    $wrapper = $('.main-wrapper');
    let $pageWrapper;
    $pageWrapper = $('.page-wrapper');
    let $slimScrolls;
    $slimScrolls = $('.slimscroll');

    // Sidebar
    let Sidemenu;
    // tslint:disable-next-line: typedef
    Sidemenu = function () {
      this.$menuItem = $('#sidebar-menu a');
    };

    // tslint:disable-next-line: typedef
    function init() {
      let $this;
      $this = Sidemenu;
      // tslint:disable-next-line: typedef
      $('#sidebar-menu a').on('click', function (e) {
        if ($(this).parent().hasClass('submenu')) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
        if (!$(this).hasClass('subdrop')) {
          $('ul', $(this).parents('ul:first')).slideUp(350);
          $('a', $(this).parents('ul:first')).removeClass('subdrop');
          $(this).next('ul').slideDown(350);
          $(this).addClass('subdrop');
        } else {
          $(this).removeClass('subdrop');
          $(this).next('ul').slideUp(350);
        }
      });

      if (localStorage.getItem('mini-sidebar') === '0') {
        $('body').removeClass('mini-sidebar');
      } else {
        $('body').addClass('mini-sidebar');
      }
    }

    // Sidebar Initiate
    init();

    // Mobile menu sidebar overlay

    // tslint:disable-next-line: typedef // tslint:disable-next-line: only-arrow-functions
    $(document).on('click', '#mobile_btn', function () {
      $wrapper.toggleClass('slide-nav');
      $('.sidebar-overlay').toggleClass('opened');
      $('html').addClass('menu-opened');
      $('#task_window').removeClass('opened');
      return false;
    });

    // tslint:disable-next-line: typedef
    $('.sidebar-overlay').on('click', function () {
      $('html').removeClass('menu-opened');
      $(this).removeClass('opened');
      $wrapper.removeClass('slide-nav');
      $('.sidebar-overlay').removeClass('opened');
      $('#task_window').removeClass('opened');
    });

    // tslint:disable-next-line: typedef // tslint:disable-next-line: only-arrow-functions
    $(document).on('mouseover', function (e) {
      e.stopPropagation();
      if (
        $('body').hasClass('mini-sidebar') &&
        $('#toggle_btn').is(':visible')
      ) {
        let targ = $(e.target).closest('.sidebar').length;
        targ = $(e.target).closest('.sidebar').length;
        if (targ) {
          $('body').addClass('expand-menu');
          $('.subdrop + ul').slideDown();
        } else {
          $('body').removeClass('expand-menu');
          $('.subdrop + ul').slideUp();
        }
        return false;
      }
    });
  }

  ssoLogin(link): void {
    this.genService.ssoLogin({ from: link }).subscribe(
      (res) => {
        this.response = res;
        if (this.response.data.status == 1) {
          window.open(this.response.data.url, '_blank');
        } else {
          this.notifyService.showError(this.response.data.msg);
        }
      },
      (err) => {
        this.notifyService.showError('Internal Server Error!');
      }
    );
  }

  goto(data): void {
    if (data.smnu_id == '263'){
      this.ssoLogin('sendsms');
      return;
    }
    if (data.smnu_id == '153'){
      this.ssoLogin('aspire');
      return;
    }
    if (data.smnu_id == '154'){
      this.ssoLogin('manage_aspire');
      return;
    }



    if (data.smnu_id == '160'){
      this.employeeIdCard();
      return;
    }
    // if (data.smnu_id == '261'){
    //   this.technicalSupport();
    //   return;
    // }
    if (data.smnu_id == '262'){
      this.sodexoPortalLink();
      return;
    }

    const links = data.link;
    const ext = links.split('.');
    const imgExt = ['pdf', 'PDF', 'jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG'];
    if (ext.length >= 2) {
      const urlExt = ext[ext.length - 1];
      if (imgExt.includes(urlExt)) {
        window.open(data.link, '_self');
      } else {
        window.open(data.link, '_self');
      }

    } else {
      var url = data.portal_url;
      if(data.op_portal_url!=''){
        url = data.op_portal_url;
      }
      if(url==document.location.origin){
        this.store.dispatch(isQuickLinks({ status: true }));
        this.router.navigate(['/' + data.link]);
      }else{
        this.authSer.appLogin(data.link).subscribe(res => {

          // window.open(url + '/#/auth/app-login/' + res.data, '_self');
          let route = environment.routing;
          let ren = environment.routingEnable;
          if(ren){
            window.open(url + '/#/auth/app-login/' + res.data, '_self');
          }else{
            window.open(route + '/#/auth/app-login/' + res.data, '_self');
          }
        },
        err => {
          this.notifyService.showError('Something Went Wrong');
        });
      }
    }
  }

  sodexoPortalLink(): void {
    $('#sodexo-portal-link').modal({ backdrop: 'static', keyboard: false });
  }

  employeeIdCard(): void {
    $('#employee_idcard').modal({ backdrop: 'static', keyboard: false });
  }

  idCardDetails(empID): void {
    this.hasData = false;
    this.dashboardService.empIDCardDetails(empID).subscribe((res) => {
      this.hasData = true;
      this.empIDInfo = res.data;
    });
  }

  childOutput(event): void {
    if (event.isAdd) {
      this.idCardDetails('');
    } else if (event.emp_id != '') {
      this.idCardDetails(event.emp_id);
    }
  }
}
